export default { T3_PREFIX: 't3' };
